// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__bdiWj","headingText":"styles_headingText__GqMkJ","text":"styles_text__PUSzD"};